import { Card } from '../../Card'
import { CardHeader } from '../../CardHeader'
import StatsIcon from '@/CustomIcons/StatsIcon'
import { Field } from '../../Field'
import { SystemStats } from '@/functionalities/SystemStats/SystemStats'

interface NetworkStatsSectionProps {
    systemStats: SystemStats
    aeNetworkStats: { serverPing: number | null }
}

export function NetworkStatsSection({ systemStats }: NetworkStatsSectionProps) {
    return (
        <>
            {systemStats.rtcOverviewStats && (
                <Card className="px-0 md:px-0">
                    <CardHeader icon={StatsIcon} title="Network Statistics" className="px-[30px]" />
                    <div className="flex flex-col gap-[10px] pt-[41px] w-full">
                        <Field title="State">{systemStats.rtcOverviewStats.state}</Field>
                        <Field title="Current round trip time">
                            {systemStats.rtcOverviewStats.currentRoundTripTime * 1000} ms
                        </Field>
                        <Field title="Available bitrate">{systemStats.rtcOverviewStats.availableOutgoingBitrate}</Field>
                        <Field title="Bytes sent">{systemStats.rtcOverviewStats.bytesSent}</Field>
                        <Field title="Bytes received">{systemStats.rtcOverviewStats.bytesReceived}</Field>
                        <Field title="Bytes sent / s">
                            {systemStats.rtcOverviewStats.calculatedBytesSentPerSecond}
                        </Field>
                        <Field title="Bytes received / s">
                            {systemStats.rtcOverviewStats.calculatedBytesReceivedPerSecond}
                        </Field>
                        <Field title="Packets discarded">{systemStats.rtcOverviewStats.packetsDiscardedOnSend}</Field>
                    </div>
                </Card>
            )}
        </>
    )
}
